import { useEffect, useState } from "react";
import { CalendarDays, Loader2, RefreshCw, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import CustomerLayout from "@/components/customer/CustomerLayout";
import apiClient from "@/lib/api";
import { SURVEY_STATUS_LABELS, SURVEY_STATUS_STYLES, formatDate } from "@/components/booking/bookingMeta";

export default function CustomerSurveysPage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    apiClient.get("/surveys").then((r) => setRows(r.data || [])).catch(() => setRows([])).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  return (
    <CustomerLayout>
      <div className="flex items-center justify-between gap-3 mb-6">
        <div>
          <h1 className="font-heading text-2xl font-bold flex items-center gap-2"><CalendarDays size={22} className="text-primary" /> Survei Saya</h1>
          <p className="text-sm text-muted-foreground">Jadwal kunjungan properti yang Anda ajukan.</p>
        </div>
        <button onClick={load} data-testid="customer-surveys-refresh"
          className="grid place-items-center w-10 h-10 rounded-full border border-border hover:bg-secondary/60 transition-colors">
          <RefreshCw size={16} className={loading ? "animate-spin" : ""} />
        </button>
      </div>

      {loading ? (
        <div className="py-16 grid place-items-center"><Loader2 className="animate-spin text-primary" size={26} /></div>
      ) : rows.length === 0 ? (
        <div className="py-16 text-center text-muted-foreground" data-testid="customer-surveys-empty">
          <CalendarDays size={30} className="mx-auto mb-2" />
          <p>Belum ada jadwal survei.</p>
          <button onClick={() => navigate("/search")} className="mt-3 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary text-primary-foreground text-sm font-semibold">
            <Search size={15} /> Cari Hunian
          </button>
        </div>
      ) : (
        <div className="space-y-3" data-testid="customer-surveys-list">
          {rows.map((s, i) => (
            <div key={s.id} className="bg-card border border-border rounded-2xl p-4 flex items-start justify-between gap-3 flex-wrap" data-testid={`customer-survey-${i}`}>
              <div className="min-w-0">
                <p className="font-semibold">{s.property_name || "Properti"}{s.room_number ? ` · Kamar ${s.room_number}` : ""}</p>
                <p className="mt-1 text-sm"><span className="font-medium">{formatDate(s.survey_date)}</span> · {s.survey_time || "-"}</p>
                {s.notes && <p className="mt-1 text-sm text-muted-foreground">“{s.notes}”</p>}
              </div>
              <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full border ${SURVEY_STATUS_STYLES[s.status] || ""}`} data-testid={`customer-survey-status-${i}`}>
                {SURVEY_STATUS_LABELS[s.status] || s.status}
              </span>
            </div>
          ))}
        </div>
      )}
    </CustomerLayout>
  );
}
